import { animate, group, query, style, transition, trigger } from '@angular/animations';

const resetRoute = [
  style({ position: 'relative' }),
  query(
    ':enter, :leave',
    [
      style({
        position: 'absolute',
        top: 0,
        left: 0,
        opacity: 0,

        // container-fluid
        width: '100%',
        paddingTop: 'inherit',
        paddingRight: '15px',
        paddingLeft: '15px',
        marginRight: 'auto',
        marginLeft: 'auto',
      }),
    ],
    { optional: true }
  ),
];

export const simpleFadeAnimation = trigger('simpleFadeAnimation', [
  transition('* => *', [
    ...resetRoute,
    query(':enter', [style({ opacity: 0 })], {
      optional: true,
    }),
    group([
      query(':leave', [style({ opacity: 1 }), animate('0.3s ease-out', style({ opacity: 0 }))], { optional: true }),
      query(':enter', [style({ opacity: 0 }), animate('0.3s ease-in', style({ opacity: 1 }))], { optional: true }),
    ]),
  ]),
]);
